<template>
  <div v-loading="loading" class="users evaluation-users-table">
    <div class="header-actions">
      <search-input
        placeholder="Поиск по ФИО"
        style="width: 300px"
        v-model="filters.search"
        @change="filtersChanged"
      >
      </search-input>
      <div slot="right">
        <div class="el-row--flex">
          <add-users-builder
            v-if="!isProfileError && !isDisabledSetting"
            :entity-type="$constants.visualQueryBuilder.formEntityTypes.TYPE_EVAL_EVALUATION_USERS"
            :entity-id="$route.params.id"
            entity-report-key="users"
            delete-on-empty-search
            @after-save="createMembers"
          ></add-users-builder>
        </div>
      </div>
    </div>
    <div class="evaluation_users-block">
      <div v-if="isProfileError && totalProfileErrorCount > 0" class="info">
        <p>У данных пользователей отсутствует профиль или их несколько.</p>
        <p><b>Решите ошибки профилей, чтобы перевести пользователей в статус участников.</b></p>
      </div>
      <el-table :data="evaluation_users" border>
        <el-table-column width="150" prop="user.persnum" label="Перс. №"></el-table-column>
        <el-table-column prop="user.full_name" label="ФИО"></el-table-column>
        <el-table-column prop="user.email" label="Email"></el-table-column>
        <el-table-column prop="user.position" label="Должность"></el-table-column>
        <el-table-column prop="user.subdivision" label="Подразделение"></el-table-column>
        <el-table-column prop="user.company" label="Компания"></el-table-column>
        <el-table-column v-if="!isProfileError" label="Выбранный профиль" :formatter="(row) => (row && row.profile && row.profile.name) ? row.profile.name : ''"></el-table-column>
        <el-table-column v-if="isProfileError && !isDisabledSetting" width="300" align="center" label="Выбор профиля">
          <template v-slot="scope">
            <div v-if="scope.row.profiles.length">
              <el-select
                v-model="scope.row.profile_id"
                style="width: 100%"
                size="size"
                placeholder="Профили пользователя"
                no-data-text="У пользователя отсутствует профиль"
                @change="updateEvaluationUser(scope.row)"
              >
                <el-option
                  v-for="profile in scope.row.profiles"
                  :key="profile.profile.id"
                  :label="profile.profile.name"
                  :value="profile.profile.id"
                />
              </el-select>
            </div>
            <p v-else>У пользователя отсутствует профиль</p>
          </template>
        </el-table-column>
        <el-table-column v-if="!isDisabledSetting" width="90" align="center">
          <template v-slot="scope">
            <el-popconfirm
              confirm-button-text='Да'
              cancel-button-text='нет'
              icon="el-icon-question"
              title="Вы уверены, что хотите удалить участника с оценки?"
              @confirm="deleteEvaluationUser(scope.row)"
            >
              <el-button
                slot="reference"
                class="table-action-button"
                size="mini"
                round
                icon="far fa-trash-alt"
              >
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <paginator
      :paginator.sync="paginator"
      use-router-query-param
      @page-changed="loadEvaluationUsers"
    ></paginator>
  </div>
</template>

<script>
import Paginator from "@/components/Paginator";
import {paginator} from "@/mixins/paginator";
import SearchInput from "@/components/filters/SearchInput.vue";
import AddUsersBuilder from "@/modules/evaluation/components/AddUsersBuilder.vue";

export default {
  name: "evaluation-users-table",
  components: {AddUsersBuilder, SearchInput, Paginator},
  props: {
    isProfileError: {
      type: Boolean,
      required: false,
      default: false,
    },
    totalProfileErrorCount: {
      type: Number,
      required: false,
      default: 0,
    },
    isDisabledSetting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      evaluation_users: [],
      filters: {},
    }
  },
  mixins: [paginator],
  mounted() {
    this.loadEvaluationUsers();
  },
  beforeMount() {
    this.paginator.perPage = 10;
  },
  methods: {
    createMembers() {
      this.loading = true;
      this.$api.evaluation.evaluationUserCreate({
        evaluation_id: this.$route.params.id,
      })
        .then(data => {
          this.refreshAll()
        })
        .finally(() => {
          this.loading = false;
        })
    },
    updateEvaluationUser(user) {
      this.loading = true;
      this.$api.evaluation.evaluationUserUpdate({
        id: user.id,
        profile_id: user.profile_id,
      })
        .then(data => {
          this.$notify.success({
            title: 'Успех',
            message: 'Пользователь переведен в статус участника'
          });
        })
        .finally(() => {
          this.loading = false;
          this.refreshAll();
        })
    },
    loadEvaluationUsers() {
      this.loading = true;
      this.$api.evaluation.evaluationUserSearch({
        ...this.filters,
        expand: (!this.isProfileError ? ['user', 'profile'].join() : ['user', 'profiles.profile'].join()),
        statuses: (!this.isProfileError ? ['available', 'done'] : ['error']),
        evaluation_id: this.$route.params.id,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator}) => {
          this.evaluation_users = data.evaluation_users;
          this.paginatorFill(paginator);

          this.$emit("update-total-count", data.allEvaluationUsersInfo);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    deleteEvaluationUser(evaluationUser) {
      this.loading = true;
      this.$api.evaluation.evaluationUserDelete({
        ids: [evaluationUser.id],
      })
        .then(data => {
          this.$notify.success({
            title: 'Удалено',
            message: 'Пользователь с оценки успешно удален'
          });
        })
        .finally(() => {
          this.loadEvaluationUsers();
          this.refreshAll();
        })
    },
    filtersChanged() {
      this.loadEvaluationUsers();
    },
    refreshAll() {
      this.$emit('refresh-all');
    },
  }
}
</script>

<style scoped lang="scss">
  .evaluation-users-table {
    .evaluation_users-block {
      margin: 25px 0;
    }

    .members .el-card {
      border: none !important;
    }

    .header-actions {
      display: flex;
      justify-content: space-between;
    }

    .info {
      font-size: 15px;
      color: #4b4b4b;
      margin-bottom: 20px;
    }

    .info p {
      margin: 0 0 5px 0;
    }

    .info p:first-child {
      color: #ff8282;
    }
  }
</style>